import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaEnvelope } from 'react-icons/fa';
import './footer.css';
import logo from '../Asset/crovate.png'; // Import your logo

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* Logo */}
        <div className="footer-logo">
          <img src={logo} alt="Logo" className="footer-logo-img" />
        </div>

        {/* Navigation Links */}
        <div className="footer-nav">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/services/logo" className="footer-link">Services</Link>
          {/* <Link to="/contact" className="footer-link">Contact</Link> */}
        </div>

        {/* Social and Mail */}
        <div className="footer-socials">
          
          {/* Instagram */}
          <a href="https://www.instagram.com/creovate.tech" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <FaInstagram className="footer-icon" />
          </a>

          {/* Mail */}
          <a href="mailto:creovate.tech@gmail.com" className="footer-social-link mail-link">
            <FaEnvelope className="footer-icon" />
            <span className="mail-text">creovate.tech@gmail.com</span>
          </a>

        </div>
      </div>

      <div className="footer-bottom">
        Creovate Tech | All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
